import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import AdministracionPage from '../modules/administracion/AdministracionPage'

const PrivateRoutes = () => {
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const CatalogoPage = lazy(() => import('../modules/catalogo/CatalogoPage'))
  const TransaccionesPage = lazy(() => import('../modules/transacciones/TransaccionesPage'))
  const DisponibilidadesPage = lazy(
    () => import('../modules/disponibilidades/DisponibilidadesPage')
  )
  const ConfiguracionPage = lazy(() => import('../modules/configuracion/ConfiguracionPage'))
  const FacturacionPage = lazy(() => import('../modules/facturacion/FacturacionPage'))
  const VentasPage = lazy(() => import('../modules/ventas/VentasPage'))
  const ChatPage = lazy(() => import('../modules/chat/ChatPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<DashboardWrapper />} />

        <Route
          path='menu/catalogo/*'
          element={
            <SuspensedView>
              <CatalogoPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/transacciones/*'
          element={
            <SuspensedView>
              <TransaccionesPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/disponibilidades/*'
          element={
            <SuspensedView>
              <DisponibilidadesPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/configuracion/*'
          element={
            <SuspensedView>
              <ConfiguracionPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/administracion/*'
          element={
            <SuspensedView>
              <AdministracionPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/facturacion/*'
          element={
            <SuspensedView>
              <FacturacionPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/ventas/*'
          element={
            <SuspensedView>
              <VentasPage />
            </SuspensedView>
          }
        />

        <Route
          path='menu/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
